export class BookAdditional {

    id: number;
    cover: string;
    title: string;
    typeId: number;
    lastUpdated: Date;
    productLink: string;
    files: Array<BookAdditionalFile>;
    typeIconUrl: string;
}

export class BookAdditionalFile {

    title: string;
    link: string;
    bookLink: string;
    isPdf: boolean;
    isWord: boolean;
    isExcel: boolean;
}

export class BookAdditionalType {

    id: number;
    name: string;
    iconUrl: string;
}
